<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="videocam"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content
        [class.cardContentFullscreen]="!subtitle"
        [class.cardContentFullscreenSubtitle]="subtitle"
        class="card-content-crear"
      >
        <!-- Datos Básicos -->
        <app-content-card title="Datos Básicos" icon="videocam" color="red">
          <section class="inputs-group">
            <!-- Identificación -->
            <div class="form-field-wrapper" style="width: 100%">
              <mat-form-field class="no-hint" style="width: 100%">
                <mat-label>Identificación</mat-label>
                <input
                  matInput
                  formControlName="identificacion"
                  [errorStateMatcher]="chequeo.matcher"
                />
                <mat-icon matPrefix>badge</mat-icon>
              </mat-form-field>
              <app-mensaje-identificacion
                [chequeo]="chequeo"
              ></app-mensaje-identificacion>
            </div>
          </section>
        </app-content-card>

        <!-- Cliente -->
        @if (
          !camara &&
          !this.paramsService.getParams()?.['desdeAlarma'] &&
          mostrarCamposCliente
        ) {
          <app-content-card title="Cliente" icon="business" color="orange">
            <div class="client-section-wrapper">
              <div class="client-fields">
                <section class="inputs-group">
                  <div style="width: 100%">
                    <label class="field-label">Cliente Propietario *</label>
                    <div style="display: flex; gap: 8px">
                      <app-cliente-selector
                        formControlName="idCliente"
                        placeholder="Buscar y seleccionar cliente *"
                        (clienteChange)="onClienteChange($event)"
                        style="flex: 1"
                        [filterModules]="[
                          'moduloAlarmasDomiciliarias',
                          'moduloSirenas',
                        ]"
                        [showCrearBtn]="
                          helper.tienePermiso('Administración - Crear clientes')
                        "
                      ></app-cliente-selector>
                    </div>
                  </div>
                </section>
              </div>

              <!-- Gráfico de jerarquía de clientes -->
              @if (idCliente) {
                <div class="client-hierarchy">
                  <div class="hierarchy-title">Jerarquía</div>
                  <app-jerarquia-cliente
                    [idCliente]="idCliente"
                  ></app-jerarquia-cliente>
                </div>
              }
            </div>
          </app-content-card>
        }

        <!-- Modelo y Configuración -->
        <app-content-card
          title="Modelo y Configuración"
          icon="settings_input_antenna"
          color="blue"
        >
          <section class="inputs-group" style="flex-direction: column">
            <!-- Tipo de dispositivo: NVR o Cámara -->
            <div style="width: 100%">
              <label class="field-label">Tipo de dispositivo</label>
              <irx-segmentado
                [value]="tipoModeloSeleccionado"
                (change)="onTipoModeloChange($event.value)"
                bloque
              >
                <irx-segmento value="Cámara" style="flex: 1">
                  <mat-icon>videocam</mat-icon>
                  Cámara
                </irx-segmento>
                <irx-segmento value="NVR" style="flex: 1">
                  <mat-icon>video_library</mat-icon>
                  NVR
                </irx-segmento>
              </irx-segmentado>
            </div>

            <!-- Modelo NVR + Tipo de Cámara side by side -->
            <div style="display: flex; gap: 1em; align-items: center">
              <!-- Tipo de Cámara -->
              <ng-select
                [fixedPlaceholder]="true"
                [items]="tiposDeCamara"
                formControlName="tipo"
                placeholder="Tipo de cámara*"
                style="width: 100%"
                multiple="false"
                searchable="true"
                appendTo="body"
                (change)="ajustarTipoCamara($event)"
              ></ng-select>

              @if (esNVR) {
                <app-modelo-dispositivo-selector
                  tipo="NVR"
                  placeholder="Buscar y seleccionar modelo *"
                  formControlName="idModeloDispositivo"
                  [showCrearBtn]="
                    helper.tienePermiso(
                      'Configuraciones - Crear modelos cámaras'
                    )
                  "
                ></app-modelo-dispositivo-selector>
              }
            </div>
          </section>
        </app-content-card>

        <!-- Configuración de Conexión -->
        <app-content-card
          title="Configuración de Conexión"
          icon="router"
          color="green"
        >
          <section class="inputs-group">
            @if (
              this.form?.value?.tipo === 'Hikvision' ||
              this.form?.value?.tipo === 'Dahua'
            ) {
              <div class="conexion-fields">
                <mat-form-field class="field-full">
                  <mat-label>IP / Dominio</mat-label>
                  <input matInput formControlName="host" required />
                  <mat-icon matPrefix>dns</mat-icon>
                </mat-form-field>

                <mat-form-field class="field-half">
                  <mat-label>Puerto RTSP</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="puertoRTSP"
                    required
                  />
                  <mat-icon matPrefix>usb</mat-icon>
                </mat-form-field>

                <mat-form-field class="field-half">
                  <mat-label>Puerto HTTP</mat-label>
                  <input matInput type="number" formControlName="puertoHTTP" />
                  <mat-icon matPrefix>http</mat-icon>
                </mat-form-field>
              </div>
            }

            @if (
              form?.value?.tipo === 'Hikvision P2P' ||
              form?.value?.tipo === 'Dahua P2P'
            ) {
              <div class="conexion-fields">
                <mat-form-field class="field-full">
                  <mat-label>Número de serie</mat-label>
                  <input matInput formControlName="numeroSerie" required />
                  <mat-icon matPrefix>tag</mat-icon>
                  @if (
                    form?.get('numeroSerie')?.hasError('minlength') &&
                    (form?.get('numeroSerie')?.dirty ||
                      form?.get('numeroSerie')?.touched)
                  ) {
                    <mat-error>
                      Mínimo
                      {{
                        form?.get('numeroSerie')?.getError('minlength')
                          ?.requiredLength
                      }}
                      caracteres
                    </mat-error>
                  }
                  @if (
                    form?.get('numeroSerie')?.hasError('maxlength') &&
                    (form?.get('numeroSerie')?.dirty ||
                      form?.get('numeroSerie')?.touched)
                  ) {
                    <mat-error>
                      Máximo
                      {{
                        form?.get('numeroSerie')?.getError('maxlength')
                          ?.requiredLength
                      }}
                      caracteres
                    </mat-error>
                  }
                  @if (
                    form?.get('numeroSerie')?.hasError('pattern') &&
                    (form?.get('numeroSerie')?.dirty ||
                      form?.get('numeroSerie')?.touched)
                  ) {
                    <mat-error>
                      Solo letras y números (sin espacios ni símbolos)
                    </mat-error>
                  }
                </mat-form-field>

                @if (form?.value?.tipo === 'Hikvision P2P') {
                  <mat-form-field class="field-full">
                    <mat-label>Clave de Encriptación</mat-label>
                    <input matInput formControlName="claveDeEncriptacion" />
                    <mat-icon matPrefix>key</mat-icon>
                  </mat-form-field>
                }
              </div>
            }

            <!-- Credenciales -->
            <div class="conexion-fields">
              <mat-form-field class="field-half">
                <mat-label>Usuario</mat-label>
                <input matInput formControlName="usuario" />
                <mat-icon matPrefix>person</mat-icon>
              </mat-form-field>

              <mat-form-field class="field-half">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="inputType" formControlName="password" />
                <mat-icon matPrefix>lock</mat-icon>
                @if (inputType === 'password') {
                  <button
                    irxBotonIcono
                    matSuffix
                    tooltip="Mostrar contraseña"
                    (click)="onClickShowPassword()"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
                @if (inputType === 'text') {
                  <button
                    irxBotonIcono
                    matSuffix
                    tooltip="Ocultar contraseña"
                    (click)="onClickShowPassword()"
                  >
                    <mat-icon>visibility_off</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </section>

          <!-- Credenciales del portal del fabricante. Van en una section
               aparte porque .inputs-group es una FILA: acá adentro serían una
               tercera columna angosta, con media tarjeta vacía al lado. -->
          @if (
            form?.value?.tipo === 'Hikvision P2P' ||
            form?.value?.tipo === 'Dahua P2P'
          ) {
            <section class="inputs-group">
              <div class="conexion-fields">
                @if (form?.value?.tipo === 'Hikvision P2P') {
                  <div class="ayuda-credenciales">
                    <div class="ayuda-titulo">
                      <mat-icon>help_outline</mat-icon>
                      <span>Dónde conseguir estas credenciales</span>
                    </div>
                    <ol class="ayuda-pasos">
                      <li>
                        Entrá a
                        <strong>Hik-Partner Pro</strong>
                        e iniciá sesión.
                      </li>
                      <li>
                        Abrí
                        <strong>Site &amp; Device</strong>
                        →
                        <strong>My Service</strong>
                        →
                        <strong>API Integration</strong>
                        .
                      </li>
                      <li>
                        Copiá
                        <strong>Account (API Key)</strong>
                        en App Key y
                        <strong>Password (API Secret)</strong>
                        en Secret Key.
                      </li>
                    </ol>
                  </div>

                  <mat-form-field
                    class="field-half"
                    [formGroup]="credencialesHikvision"
                  >
                    <mat-label>App Key (Account / API Key)</mat-label>
                    <input
                      matInput
                      formControlName="appKey"
                      placeholder="Ej: kqmzrvbtyh"
                      required
                    />
                    <mat-icon matPrefix>key</mat-icon>
                  </mat-form-field>

                  <mat-form-field
                    class="field-half"
                    [formGroup]="credencialesHikvision"
                  >
                    <mat-label>Secret Key (Password / API Secret)</mat-label>
                    <input
                      matInput
                      formControlName="secretKey"
                      placeholder="Ej: p7w2x9fd4c"
                      required
                    />
                    <mat-icon matPrefix>key</mat-icon>
                  </mat-form-field>
                }

                @if (form?.value?.tipo === 'Dahua P2P') {
                  <div class="ayuda-credenciales">
                    <div class="ayuda-titulo">
                      <mat-icon>help_outline</mat-icon>
                      <span>Dónde conseguir estas credenciales</span>
                    </div>
                    <ol class="ayuda-pasos">
                      <li>
                        Entrá a
                        <strong>DoLynk Developer</strong>
                        e iniciá sesión.
                      </li>
                      <li>
                        Abrí
                        <strong>Product Management</strong>
                        : ahí se listan los dispositivos con su
                        <strong>Product ID</strong>
                        .
                      </li>
                      <li>
                        En el producto que te interesa tocá
                        <strong>Develop</strong>
                        y después
                        <strong>Verify</strong>
                        : ahí aparecen
                        <strong>Access Key</strong>
                        y
                        <strong>Secret Access Key</strong>
                        .
                      </li>
                    </ol>
                  </div>

                  <mat-form-field
                    class="field-full"
                    [formGroup]="credencialesDahua"
                  >
                    <mat-label>App Key (Access Key)</mat-label>
                    <input
                      matInput
                      formControlName="acceskeyDahua"
                      placeholder="Ej: 1856402993117446144"
                    />
                    <mat-icon matPrefix>key</mat-icon>
                  </mat-form-field>

                  <mat-form-field
                    class="field-half"
                    [formGroup]="credencialesDahua"
                  >
                    <mat-label>Secret Key (Secret Access Key)</mat-label>
                    <input
                      matInput
                      formControlName="secretKeyDahua"
                      placeholder="Ej: K8pQwZrLmT4vNbXcYdHjE2sAfU6g"
                    />
                    <mat-icon matPrefix>key</mat-icon>
                  </mat-form-field>

                  <mat-form-field
                    class="field-half"
                    [formGroup]="credencialesDahua"
                  >
                    <mat-label>Product ID</mat-label>
                    <input
                      matInput
                      formControlName="productID"
                      placeholder="Ej: 402715983"
                    />
                    <mat-icon matPrefix>qr_code</mat-icon>
                  </mat-form-field>
                }
              </div>
            </section>
          }
        </app-content-card>

        <!-- Canales -->
        <app-content-card title="Canales" icon="video_library" color="purple">
          <div
            formArrayName="canales"
            class="inputs-group"
            style="flex-direction: column"
          >
            <div
              style="
                display: flex;
                justify-content: flex-end;
                margin-bottom: 16px;
              "
            >
              <app-button
                (click)="camara ? detectarCanales() : null"
                matType="mat-fab extended"
                color="primary"
                text="Detectar canales"
                icon="search"
                [tooltip]="
                  camara
                    ? 'Detectar automáticamente los canales disponibles'
                    : 'Guardá la cámara primero para detectar los canales'
                "
                [disabled]="!camara"
              ></app-button>
            </div>

            <div class="canales-container">
              @for (f of canales.controls; track f; let i = $index) {
                <div class="canal-item" [formGroupName]="i">
                  <div class="canal-fields">
                    <mat-form-field style="flex: 1" class="no-hint">
                      <mat-label>Número de canal</mat-label>
                      <input
                        matInput
                        formControlName="numero"
                        type="number"
                        placeholder="1"
                        (change)="ajustarCanal($event, i)"
                      />
                      <mat-icon matPrefix>tag</mat-icon>
                    </mat-form-field>

                    <mat-form-field style="flex: 2" class="no-hint">
                      <mat-label>Nombre de canal</mat-label>
                      <input
                        matInput
                        formControlName="nombre"
                        placeholder="Puerta delantera"
                      />
                      <mat-icon matPrefix>label</mat-icon>
                    </mat-form-field>

                    @if (tipoModeloSeleccionado) {
                      <app-modelo-dispositivo-selector
                        style="flex: 2"
                        tipo="Cámara"
                        formControlName="idModeloDispositivo"
                        [showCrearBtn]="
                          helper.tienePermiso(
                            'Configuraciones - Crear modelos cámaras'
                          )
                        "
                      ></app-modelo-dispositivo-selector>

                      <!-- <ng-select
                        [fixedPlaceholder]="true"
                        [items]="modelosCamaraParaCanales"
                        bindValue="_id"
                        formControlName="idModeloDispositivo"
                        placeholder="Modelo de cámara"
                        [notFoundText]="'No hay modelos de cámara creados'"
                        style="flex: 2"
                        multiple="false"
                        searchable="true"
                        appendTo="body"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          <span>{{ item.marca }} - {{ item.modelo }}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span>{{ item.marca }} - {{ item.modelo }}</span>
                        </ng-template>
                      </ng-select>
                      <button
                        irxBotonIcono="relleno"
                        type="button"
                        (click)="crearModeloCamaraParaCanal()"
                        tooltip="Crear modelo de cámara"
                      >
                        <mat-icon>add</mat-icon>
                      </button> -->
                    }

                    <ng-select
                      style="flex: 1.5"
                      formControlName="tipoHabilitacion"
                      placeholder="Tipo de habilitación"
                      [items]="tiposHabilitacion"
                      [clearable]="false"
                      required
                      appendTo="body"
                      notFoundText="Sin resultados"
                    ></ng-select>
                  </div>

                  <div class="canal-actions">
                    <button
                      irxBotonIcono="borde"
                      tono="primario"
                      type="button"
                      (click)="detallesCanal(i)"
                      tooltip="Ver detalles"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>

                    @if (tipoModeloSeleccionado !== 'Cámara') {
                      <button
                        irxBotonIcono
                        tono="peligro"
                        type="button"
                        (click)="removeCanal(i)"
                        tooltip="Eliminar canal"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>

            <div
              style="display: flex; justify-content: center; margin-top: 16px"
            >
              <app-button
                matType="mat-fab extended"
                [disabled]="
                  !this.form.value.tipo ||
                  (tipoModeloSeleccionado === 'Cámara' && canales.length >= 1)
                "
                [tooltip]="
                  tipoModeloSeleccionado === 'Cámara' && canales.length >= 1
                    ? 'Una cámara solo puede tener un canal'
                    : ''
                "
                color="primary"
                (click)="addCanal()"
                text="Agregar canal"
                icon="add"
              ></app-button>
            </div>
          </div>
        </app-content-card>
      </mat-card-content>
      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
